module.exports = __webpack_public_path__ + "img/mythic.b9a08e91.png";